// Shared presentation for the Biomarker Browser dashboards (By Treatment / By Prognosis),
// so both flows stay visually identical instead of drifting apart via duplicated styles.

export const roundedSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '44px',
    borderRadius: '12px',
    borderColor: state.isFocused ? '#545cd8' : '#e3e5ee',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(84,92,216,0.12)' : 'none',
    fontSize: '0.85rem',
    cursor: 'pointer',
    background: '#fff',
    '&:hover': { borderColor: '#545cd8' },
  }),
  menu: (base) => ({ ...base, borderRadius: '12px', overflow: 'hidden', zIndex: 20 }),
  menuList: (base) => ({ ...base, padding: '4px' }),
  option: (base, state) => ({
    ...base,
    fontSize: '0.85rem',
    cursor: 'pointer',
    borderRadius: '8px',
    backgroundColor: state.isSelected ? '#545cd8' : state.isFocused ? 'rgba(84,92,216,0.08)' : '#fff',
    color: state.isSelected ? '#fff' : '#333333',
  }),
  valueContainer: (base) => ({ ...base, padding: '2px 12px' }),
  indicatorSeparator: () => ({ display: 'none' }),
};

export const multiSelectStyles = {
  ...roundedSelectStyles,
  control: (base, state) => ({
    ...roundedSelectStyles.control(base, state),
    background: state.hasValue ? 'rgba(84,92,216,0.06)' : '#fff',
  }),
  placeholder: (base) => ({ ...base, fontSize: '0.85rem', fontWeight: 600, color: '#333333' }),
};

export const dataTableCustomStyles = {
  headRow: { style: { backgroundColor: '#f7f9fc', minHeight: '46px', borderBottom: '1px solid #eef0f4' } },
  headCells: { style: { fontSize: '0.72rem', fontWeight: 700, color: '#4b4f5e', textTransform: 'uppercase', letterSpacing: '0.02em' } },
  rows: {
    style: { minHeight: '44px', fontSize: '0.78rem', color: '#333333' },
    highlightOnHoverStyle: { backgroundColor: '#f7f8ff', borderBottomColor: '#eef0f4', outline: 'none', cursor: 'pointer' },
  },
  cells: { style: { padding: '8px 10px' } },
};

export const formatStat = (value, digits = 4) => {
  const num = Number(value);
  if (value === null || value === undefined || value === '' || Number.isNaN(num)) return '—';
  return num.toFixed(digits);
};

export const estimateColor = (value) => {
  const num = Number(value);
  if (Number.isNaN(num) || num === 0) return '#333333';
  return num > 0 ? '#15803d' : '#b91c1c';
};
